const MyTeamsActivity = () => {
    return (
        <div>
            <h1>My Teams Activity</h1>
        </div>
    );
};

export default MyTeamsActivity;
